export const GET_SEARCH_DATA = "GET_SEARCH_DATA";
export const SET_SEARCH_VAUE = "SET_SEARCH_VAUE";
export const SET_SEARCH_LOADER = "SET_SEARCH_LOADER";
export const GET_BLOGS_SEARCH_DATA = "GET_BLOGS_SEARCH_DATA";
export const GET_RESOURCE_SEARCH_DATA = "GET_RESOURCE_SEARCH_DATA";
export const GET_TOOLBOX_SEARCH_DATA = "GET_TOOLBOX_SEARCH_DATA";
export const GET_FORMS_SEARCH_DATA = "GET_FORMS_SEARCH_DATA";
export const CLEAR_SEARCH_DATA = "CLEAR_SEARCH_DATA";
